var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 335,
    height: 264.258,
    viewBox: "0 0 335 264.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f9edd3;}.b,.c,.d,.g,.h{fill:none;}.b,.d,.h{stroke:#f49e00;}.b,.d{stroke-width:5px;}.d{stroke-linecap:round;}.e{fill:#f49e00;}.f{fill:#ec130f;}.h{stroke-width:2px;}.i,.j{stroke:none;}.j{fill:#f49e00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-215 -300.742)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1807.28-2781.648c18.849,6.86,43.131,8.637,70.187-4.992s93.025-27.079,133.206-14.375,32.068,99.039,32.068,99.039-5.4,93.332-73.773,107.87-106.488-33.386-106.488-33.386-35.172-27.922-71.211-11.43-73.388-61.744-57.716-100.015S1788.431-2788.508,1807.28-2781.648Z",
    transform: "translate(-1504.146 3136.954)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(271 347)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M285.5-1172.469H497.978",
    transform: "translate(-281.953 1214)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0 -1523)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20,1523H199a20,20,0,0,1,20,20v120a20,20,0,0,1-20,20H20a20,20,0,0,1-20-20V1543A20,20,0,0,1,20,1523Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M 20 1528 C 15.99334716796875 1528 12.22653198242188 1529.560302734375 9.393402099609375 1532.393432617188 C 6.560287475585938 1535.2265625 5 1538.993408203125 5 1543 L 5 1663.000122070312 C 5 1667.006713867188 6.560287475585938 1670.773559570312 9.393402099609375 1673.606689453125 C 12.22653198242188 1676.439819335938 15.99334716796875 1678.000122070312 20 1678.000122070312 L 199 1678.000122070312 C 203.0066223144531 1678.000122070312 206.7734680175781 1676.439819335938 209.6065979003906 1673.606689453125 C 212.4397125244141 1670.773559570312 214 1667.006713867188 214 1663.000122070312 L 214 1543 C 214 1538.993408203125 212.4397125244141 1535.2265625 209.6065979003906 1532.393432617188 C 206.7734680175781 1529.560302734375 203.0066223144531 1528 199 1528 L 20 1528 M 20 1523 L 199 1523 C 210.0456848144531 1523 219 1531.954345703125 219 1543 L 219 1663.000122070312 C 219 1674.045776367188 210.0456848144531 1683.000122070312 199 1683.000122070312 L 20 1683.000122070312 C 8.95428466796875 1683.000122070312 0 1674.045776367188 0 1663.000122070312 L 0 1543 C 0 1531.954345703125 8.95428466796875 1523 20 1523 Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M300.971-1190.416h82.868",
    transform: "translate(-282 1214)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(149 18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(167 18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(185 18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9,1571Z",
    transform: "translate(62 -1460)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.145 59.478)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 20,
    height: 20,
    transform: "translate(27.355 27.355)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2.002)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M73.9,70,55.728,51.827a31.6,31.6,0,1,0-3.9,3.9L70,73.9A2.76,2.76,0,0,0,73.9,70ZM5.52,31.559A26.038,26.038,0,1,1,50.236,49.685q-.271.278-.547.547A26.026,26.026,0,0,1,5.52,31.559Z",
    transform: "translate(0 -0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M340.64,340.492l-.11.11a.5.5,0,0,1,.051-.059A.554.554,0,0,1,340.64,340.492Z",
    transform: "translate(-290.549 -290.516)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(94 157)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,0H39V28H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M 4 4 L 4 24 L 35 24 L 35 4 L 4 4 M 0 0 L 39 0 L 39 28 L 0 28 L 0 0 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 76,
    height: 4,
    rx: 2,
    transform: "translate(74 181)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 2.77,
    height: 9.924,
    rx: 1.385,
    transform: "translate(279.832 301.176) rotate(-9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 2.77,
    height: 10.889,
    rx: 1.385,
    transform: "translate(272.037 303.797) rotate(-33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 2.77,
    height: 10.444,
    rx: 1.385,
    transform: "matrix(0.669, -0.743, 0.743, 0.669, 267.327, 310.404)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 2.77,
    height: 10,
    rx: 1.385,
    transform: "translate(264.256 317.956) rotate(-60)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(470 500)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 2.5,
    cy: 2.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(537 397)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 6.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.5,
    cy: 6.5,
    r: 5.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(426 552)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 6.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.5,
    cy: 6.5,
    r: 5.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(384 523)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 5.5,
    cy: 5.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 5.5,
    cy: 5.5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(323 552)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 6.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.5,
    cy: 6.5,
    r: 5.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(289 476)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.5,
    cy: 3.5,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(215 480)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 6.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 6.5,
    cy: 6.5,
    r: 5.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(242 387)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 4.5,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.5,
    cy: 4.5,
    r: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.2c7b0e2427d62dd3096343d45cbd4eb2.svg";
export { ForwardRef as ReactComponent };